import styled from 'styled-components';

const H3 = styled.h3`
  font-size: 1.5rem;
  line-height: 1;
  margin: 0;
  margin: 8px 0px;
`;

export default H3;
